function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F2FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0BB1D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M14,27c7.168,0,13-5.832,13-13S21.168,1,14,1S1,6.832,1,14S6.832,27,14,27z M14,3  c6.065,0,11,4.935,11,11s-4.935,11-11,11S3,20.065,3,14S7.935,3,14,3z M13,12c0,0.551,0.449,1,1,1c1.654,0,3,1.346,3,3  c0,1.302-0.839,2.402-2,2.816V20h-2v-1.184c-1.161-0.414-2-1.514-2-2.816h2c0,0.551,0.449,1,1,1s1-0.449,1-1s-0.449-1-1-1  c-1.654,0-3-1.346-3-3c0-1.302,0.839-2.402,2-2.816V8h2v1.184c1.161,0.414,2,1.514,2,2.816h-2c0-0.551-0.449-1-1-1S13,11.449,13,12z   M9.713,8.475L8.486,6.896C10.083,5.656,11.989,5,14,5c4.962,0,9,4.038,9,9c0,2.011-0.656,3.917-1.896,5.514l-1.579-1.227  C20.49,17.045,21,15.562,21,14c0-3.86-3.14-7-7-7C12.438,7,10.955,7.51,9.713,8.475z M5,14c0-2.011,0.656-3.917,1.896-5.514  l1.579,1.227C7.51,10.955,7,12.438,7,14c0,3.86,3.14,7,7,7c1.562,0,3.045-0.51,4.287-1.475l1.227,1.579  C17.917,22.344,16.011,23,14,23C9.038,23,5,18.962,5,14z M25,23v4h-2v6h-4v28h-2v2h42v-2h-2V19h-2v-8h-2V7h-5V1h-2v6h-5v4h-2v8h-2  v14h-2v-6h-2v-4h-3v-5h-2v5H25z M50,61h-6v-8h6V61z M43,9h8v2h-8V9z M41,13h12v6h-2v-4h-2v4h-4v-4h-2v4h-2V13z M55,21v40h-3V51H42  v10h-3V21H55z M37,61h-2V37h-2v24h-3V37h-2v24h-3V37h-2v24h-2V35h16V61z M30,33v-2h-2v2h-3v-4h8v4H30z M31,27h-4v-2h4V27z M43,25h-2  v-2h2V25z M48,25h-2v-2h2V25z M53,25h-2v-2h2V25z M43,31h-2v-2h2V31z M48,31h-2v-2h2V31z M53,31h-2v-2h2V31z M43,37h-2v-2h2V37z   M48,37h-2v-2h2V37z M53,37h-2v-2h2V37z M43,43h-2v-2h2V43z M48,43h-2v-2h2V43z M53,43h-2v-2h2V43z M43,49h-2v-2h2V49z M48,49h-2v-2  h2V49z M53,49h-2v-2h2V49z M3,33H1v-2h2V33z M3,47H1V35h2V47z M9,40H7v-2h2V40z M7,42h2v12H7V42z M15,33h-2v-2h2V33z M15,47h-2V35h2  V47z M61,61h2v2h-2V61z M13,61h2v2h-2V61z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.e0b1d096c93449e1763ae4a3a9226f04.svg";
export { ForwardRef as ReactComponent };